<!-- eslint-disable import/no-unresolved -->
<template>
  <v-dialog persistent v-model="showDialog">
    <v-card>
      <v-toolbar dark color="secondary">
        <v-card-title>
          <i class="fal fa-phone mr-1"></i>
          <span class="headline">Release My Numbers</span>
        </v-card-title>
        <v-spacer> </v-spacer>
        <button
          type="button"
          class="btn btn-light btn-elevate-hover btn-circle btn-icon btn-sm"
          @click="showDialog = false"
        >
          <i class="fal fa-times" />
        </button>
      </v-toolbar>
      <v-card-text>
        <v-container class="kt-form">
          <h5>
            Below are the numbers that are currently associated with your
            account. Use the checkbox to exclude the number(s) from releasing.
          </h5>
          <v-data-table
            :headers="headers"
            v-model="excludedNumbers"
            :items="phoneNumbers"
            :loading="loaders.dataTable"
            show-select
          >
          </v-data-table>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="info" @click="promptConfirmationDialog">
          Release Numbers
        </v-btn>
      </v-card-actions>
    </v-card>
    <confirm-dialog
      v-if="showConfirmDialog"
      :close-dialog="closeConfirmDeleteDialog"
      :show-dialog="showConfirmDialog"
      :confirm-action="releaseNumbers"
      :loading="loaders.release"
    >
      {{ excludeNumbersStatement }}
    </confirm-dialog>
  </v-dialog>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue';
import { forEach as _forEach, isEmpty as _isEmpty } from 'lodash-es';

export default {
  name: 'ReleasePhoneNumberDialog',
  components: {
    ConfirmDialog,
  },
  data() {
    return {
      excludedNumbers: [],
      phoneNumbers: [],
      headers: [
        {
          text: 'Friendly Phone Number',
          value: 'friendly_phone_number',
          sortable: true,
        },
        {
          text: 'Phone Number',
          value: 'phone_number',
          sortable: true,
        },
        {
          text: 'Date Purchased',
          value: 'purchased_at',
          sortable: true,
        },
        {
          text: 'Last SMS Received',
          value: 'last_sms_received_at',
          sortable: true,
        },
        {
          text: 'Last Call Received',
          value: 'last_call_received_at',
          sortable: true,
        },
      ],
      loaders: {
        dataTable: true,
        release: false,
      },
      showConfirmDialog: false,
    };
  },
  computed: {
    showDialog: {
      get() {
        return this.$store.state.phoneNumbers.releaseNumberDialog;
      },
      set(payload) {
        this.$store.commit(
          'phoneNumbers/setReleasePhoneNumberDialogState',
          payload
        );
      },
    },
    user() {
      return this.$auth.user();
    },
    excludeNumbersStatement() {
      return `Are you sure you want to proceed? ${this.excludedNumbers.length} Phone Number(s) selected for exemption.`;
    },
  },
  watch: {
    showDialog(value) {
      if (value) {
        this.fetchNumbers();
      }
    },
  },
  methods: {
    fetchNumbers() {
      this.loaders.dataTable = true;

      this.axios
        .get(`v3/phone-numbers/users/${this.user.id}`)
        .then(({ data }) => {
          const { items } = data;

          this.phoneNumbers = items;

          this.$nextTick(() => {
            this.loaders.dataTable = false;
          });
        })
        .catch(() => {
          this.loaders.dataTable = false;
        });
    },
    promptConfirmationDialog() {
      this.showConfirmDialog = true;
    },
    closeConfirmDeleteDialog() {
      this.showConfirmDialog = false;
      this.loaders.release = false;
    },
    releaseNumbers() {
      const formData = new FormData();
      if (!_isEmpty(this.excludedNumbers)) {
        _forEach(this.excludedNumbers, (excludedNumber) => {
          formData.append('excluded_phone_numbers[]', excludedNumber.id);
        });
      }

      this.loaders.release = true;

      this.axios
        .post(`v3/phone-numbers/release/users/${this.user.id}`, formData)
        .then(({ data }) => {
          this.$notify('success', data.message);
          this.loaders.release = false;
          this.showConfirmDialog = false;
          this.showDialog = false;
        })
        .catch(() => {
          this.loaders.release = false;
        });
    },
  },
};
</script>
